<template>
    <div>
        <v-dialog v-model="dialog" max-width="600px" persistent>
            <template v-slot:activator="{ on, attrs }">
                <v-btn color="success" style="position: absolute;left:25px;top:90px;width:200px" v-bind="attrs"
                    v-on="on" v-on:click="getQr">Numara İle Aktif Et</v-btn>
            </template>
            <v-card>
                <v-card-title>Telefon Numarası Girin</v-card-title>
                <v-card-text>
                    <v-select label="Ülke Kodu Seçin" v-model="countryCode" :items="countryCodes" item-text="text"
                        item-value="value" return-object persistent-hint filled></v-select>
                    <v-text-field label="Telefon Numarası" v-model="phoneNumber"
                        :placeholder="'Telefon numarası girin'"></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="setDialog(false)">İptal</v-btn>
                    <v-btn color="green darken-1" text @click="submitPhoneNumber">Gönder</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <WhatsappPhoneCode :responseData="response" />
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import { mapActions, mapState } from 'vuex';
import QrcodeVue from 'qrcode.vue';
import WhatsappPhoneCode from './WhatsappPhoneCode.vue';
import VueCountdown from '@chenfengyuan/vue-countdown';

export default {
    components: { QrcodeVue, VueCountdown, WhatsappPhoneCode },
    props: ['account', 'device', 'fromRemove', 'phone_number'],
    name: 'WhatsappQr',
    data() {
        return {
            localDevice: this.device,
            localFromRemove: this.fromRemove,
            loader: true,
            qr: null,
            phoneNumber: null,
            response: null,
            countryCodes: [],
            countryCode: null,
            rawCountryCodes: [
                { name: 'Türkiye', code: '+90' },
                { name: 'Amerika Birleşik Devletleri', code: '+1' },
                { name: 'Kanada', code: '+1' },
                { name: 'Azerbaycan', code: '+994' },
                // AB Ülkeleri
                { name: 'Almanya', code: '+49' },
                { name: 'Fransa', code: '+33' },
                { name: 'Birleşik Krallık', code: '+44' },
                { name: 'İtalya', code: '+39' },
                { name: 'İspanya', code: '+34' },
                { name: 'Portekiz', code: '+351' },
                { name: 'İrlanda', code: '+353' },
                { name: 'Hollanda', code: '+31' },
                { name: 'Belçika', code: '+32' },
                { name: 'Lüksemburg', code: '+352' },
                { name: 'Avusturya', code: '+43' },
                { name: 'Polonya', code: '+48' },
                { name: 'Çekya', code: '+420' },
                { name: 'Macaristan', code: '+36' },
                { name: 'Slovakya', code: '+421' },
                { name: 'Danimarka', code: '+45' },
                { name: 'İsveç', code: '+46' },
                { name: 'Norveç', code: '+47' },
                { name: 'Finlandiya', code: '+358' },
                { name: 'Yunanistan', code: '+30' },
                { name: 'Kıbrıs', code: '+357' },
                { name: 'Bulgaristan', code: '+359' },
                { name: 'Romanya', code: '+40' },
                { name: 'Hırvatistan', code: '+385' },
                // Orta Avrupa Ülkeleri
                { name: 'İsviçre', code: '+41' },
                { name: 'Liechtenstein', code: '+423' },
                { name: 'Slovenya', code: '+386' },
                { name: 'Bosna Hersek', code: '+387' },
                { name: 'Sırbistan', code: '+381' },
                { name: 'Karadağ', code: '+382' },
                { name: 'Kosova', code: '+383' },
                { name: 'Arnavutluk', code: '+355' },
                { name: 'Makedonya', code: '+389' },
                { name: 'Moldova', code: '+373' },
                // Geri kalan ülkeler
                { name: 'Rusya', code: '+7' },
                { name: 'Çin', code: '+86' },
                { name: 'Hindistan', code: '+91' },
                { name: 'Endonezya', code: '+62' },
                { name: 'Suudi Arabistan', code: '+966' },
                { name: 'Japonya', code: '+81' },
                { name: 'Güney Kore', code: '+82' },
                { name: 'Bangladeş', code: '+880' },
                { name: 'Pakistan', code: '+92' },
                { name: 'Vietnam', code: '+84' },
                { name: 'Meksika', code: '+52' },
                { name: 'Brezilya', code: '+55' },
                { name: 'Arjantin', code: '+54' },
                { name: 'Güney Afrika', code: '+27' },
                { name: 'Yeni Zelanda', code: '+64' },
                { name: 'Avustralya', code: '+61' },
                { name: 'Fas', code: '+212' },
                { name: 'Mısır', code: '+20' },
                { name: 'Tunus', code: '+216' },
                { name: 'Cezayir', code: '+213' },
                { name: 'Libya', code: '+218' },
                { name: 'Kenya', code: '+254' },
                { name: 'Nijerya', code: '+234' },
                { name: 'Tanzanya', code: '+255' },
                { name: 'Uganda', code: '+256' },
                { name: 'Senegal', code: '+221' },
                { name: 'Gana', code: '+233' },
                { name: 'Sudan', code: '+249' },
                { name: 'Yemen', code: '+967' },
                { name: 'Afganistan', code: '+93' },
                { name: 'Katar', code: '+974' },
                { name: 'Bahreyn', code: '+973' },
                { name: 'Umman', code: '+968' },
                { name: 'Irak', code: '+964' },
                { name: 'Suriye', code: '+963' },
                { name: 'İsrail', code: '+972' },
                { name: 'Ürdün', code: '+962' },
                { name: 'Filistin', code: '+970' },
                { name: 'Ermenistan', code: '+374' },
                { name: 'Singapur', code: '+65' },
                { name: 'Malezya', code: '+60' },
                { name: 'Tayland', code: '+66' },
                { name: 'Kolombiya', code: '+57' },
                { name: 'Şili', code: '+56' },
                { name: 'Peru', code: '+51' },
                { name: 'Paraguay', code: '+595' },
                { name: 'Bolivya', code: '+591' },
                { name: 'Ekvador', code: '+593' },
            ],
        };
    },
    created() {
        this.fetchCountryCodes();
    },
    watch: {
        device(newVal) {
            this.localDevice = newVal;
        },
        fromRemove(newVal) {
            this.localFromRemove = newVal;
        }
    },
    computed: {
        ...mapState(['user']),
        dialog: {
            get() {
                return this.localFromRemove || this.localFromRemove === undefined ? false : this.$store.state.whatsappQrModal;
            },
            set(value) {
                this.$store.commit('updateWhatsappQrModal', value);
                return value;
            },
        },
    },
    methods: {
        ...mapActions({ send: 'sendBackend' }),
        setDialog(value) {
            this.$store.commit('updateWhatsappQrModal', value);
            window.location.reload();
        },
        fetchCountryCodes() {
            // Statik ülke kodlarını sıralama yapmadan ekle
            this.countryCodes = this.rawCountryCodes.map(country => ({
                text: `${country.name} ${country.code}`,
                value: country.code
            }));

            // Varsayılan olarak Türkiye'yi seç
            const turkeyCode = this.countryCodes.find(c => c.value === '+90');
            if (turkeyCode) {
                this.countryCode = turkeyCode.value;
            }
        },
        submitPhoneNumber() {
            const fullPhoneNumber = `${this.countryCode}${this.phoneNumber}`;
            const setDeviceRoute = 'whatsapp/set-device/number';
            this.send({
                route: setDeviceRoute,
                data: {
                    phone: fullPhoneNumber
                }
            }).then((res) => {
                if (res.status === 200) {
                    this.response = { phone: res.data.data.phone, code: res.data.data.code, reg_id: res.data.data.reg_id };
                    this.$store.commit('setShowWhatsappPhoneCodeModal', true);
                }
            });
        },
        checkDeviceActive(reg_id) {
            Vue.axios({
                url: `${this.$store.getters.apiEndpoint}whatsapp/check-device`,
                data: {
                    reg_id: reg_id
                },
                method: 'POST',
                statusCode: 500,
                responseType: 'JSON',
            }).then((res) => {
                this.account = res.data.data.account_status;
                if (res.data.data.device) {
                    this.localDevice = {
                        status: res.data.data.device,
                        sender: res.data.data.device.sender,
                        credit: res.data.data.device.credit,
                    };
                    clearInterval(this.countdownInterval);
                    this.setDialog(false);
                } else {
                    this.localFromRemove = true;
                    this.localDevice = { status: false, sender: null, credit: 0 };
                }
            }).catch(() => {
                this.localFromRemove = true;
            })
                .finally(() => {
                    this.loader = false;
                });
        },
        startCountdown(seconds, reg_id) {
            var counter = seconds;
            this.countdownInterval = setInterval(() => {
                counter--;
                this.checkDeviceActive(reg_id);
                if (counter < 0) {
                    clearInterval(this.countdownInterval);
                }
            }, 1000);
        },
        getQr() {
            this.loader = true;
            this.qr = null;
            const registerRoute = 'whatsapp/register';
            const setDeviceRoute = 'whatsapp/set-device';
            this.send({
                route: registerRoute,
            }).then((res) => {
                if (res.status == 200) {
                    this.loader = false;
                }
            });
        },
        onCountdownEnd() {
            this.getQr();
        },
    },
};
</script>
